import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  align-self: stretch;
`;

export const TitleWrapper = styled.div`
  font-size: 24px;
  font-weight: 600;
  line-height: 32px;
  letter-spacing: -0.2px;
`;

export const DescriptionWrapper = styled.div`
  text-align: center;
  max-width: 90%;
`;

export const LinkWrapper = styled.span`
  cursor: pointer;
  color: ${({ theme }) => theme.colors.green7};
  font-weight: 600;
`;
